document.addEventListener("DOMContentLoaded", function () {
  var select = document.querySelector("#locking-type");
  var customSelect = document.querySelector(".custom-select");

  if (select && customSelect && select.options.length > 1) {
    customSelect.classList.add("custom-select-wrapper");
  }
});

// Hide/show redeem sections based on customer cashback tags.
document.addEventListener("DOMContentLoaded", function () {
  var redeemTabSelector = ".get-rewards-tab";
  var rewardSelector = ".referral-reward-container";
  function getCustomerTags() {
    var bodyEl = document.body;
    var tagsString = bodyEl ? bodyEl.getAttribute("data-customer-tags") || "" : "";

    return tagsString
      .split(",")
      .map(function (tag) {
        return tag.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function applyCashbackVisibility() {
    var containers = document.querySelectorAll(rewardSelector);
    if (!containers.length) return;

    var tags = getCustomerTags();

    var tagMap = {
      cashback_05: 2,
      cashback_10: 3,
      cashback_25: 4,
      cashback_55: 5,
      cashback_100: 6,
      cashback_150: 7,
      cashback_200: 8,
      cashback_250: 9,
      cashback_500: 10,
    };

    containers.forEach(function (container) {
      container.style.display = "none";
    });

    if (!tags.length) {
      var last = containers[containers.length - 1];
      if (last) last.style.display = "block";
      return;
    }

    var rewards = Array.from(containers);
    var indexesToShow = new Set();
    indexesToShow.add(rewards.length - 1);

    tags.forEach(function (tag) {
      if (!tagMap[tag]) return;

      var index = rewards.length - tagMap[tag];
      if (index >= 0) indexesToShow.add(index);
    });

    indexesToShow.forEach(function (index) {
      if (rewards[index]) rewards[index].style.display = "block";
    });
  }

  function waitForRewards() {
    var rewards = document.querySelectorAll(rewardSelector);

    if (rewards.length) {
      applyCashbackVisibility();
      return;
    }

    var observer = new MutationObserver(function () {
      rewards = document.querySelectorAll(rewardSelector);
      if (!rewards.length) return;

      applyCashbackVisibility();
      observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("click", function (event) {
    if (!event.target.closest(redeemTabSelector)) return;

    window.setTimeout(waitForRewards, 400);
  });
});
